import { render, staticRenderFns } from "./PaginationPill.vue?vue&type=template&id=794407b6"
import script from "./PaginationPill.vue?vue&type=script&lang=js"
export * from "./PaginationPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports